import { validateApiResponseWithZod } from '@nw/shared/utils';

import { DefaultFormTypes } from '../../../types/ProductTypes';
import { DefaultFormSchema } from '../../../types/Schemas.zod';

import { DefaultFormConfigDTO } from '../../dtos/forms.dtos';

import { getFormSegmentConfigTransformer } from '../formSegmentConfigTransformer';

export const getFormConfigTransformer = (
  data: DefaultFormTypes
): DefaultFormConfigDTO => {
  const validateResponse = validateApiResponseWithZod(
    data,
    DefaultFormSchema
  ) as DefaultFormTypes;

  const {
    allowed_no_of_times_to_submit,
    form_config,
    form_field_config,
    form_info,
    form_submission_message_config,
    is_submission_edit_allowed,
    on_submit_redirect_url,
    form_validation_config,
    template_config_details
  } = validateResponse;

  const formConfig: DefaultFormConfigDTO = {
    allowedNotOfTimesToSubmit: allowed_no_of_times_to_submit,
    formConfig: getFormSegmentConfigTransformer(JSON.parse(form_config)),
    formFieldsConfig: JSON.parse(form_field_config),
    formInfo: form_info,
    formSubmissionMessageConfig: form_submission_message_config,
    isSubmissionEditAllowed: is_submission_edit_allowed,
    onSubmitRedirectUrl: on_submit_redirect_url,
    formValidationConfig: form_validation_config,
    templateConfigDetails: template_config_details
  };
  return formConfig;
};
